import { apiClient } from '../lib/apiClient';
import type { TimelineResponse, TimelineParams } from '../types/timeline';

export type { TimelineResponse, TimelineParams };

export async function getTimeline(
  aquariumId: string,
  params: TimelineParams = {},
): Promise<TimelineResponse> {
  const searchParams = new URLSearchParams();
  if (params.limit != null) searchParams.set('limit', String(params.limit));
  if (params.before) searchParams.set('before', params.before);
  if (params.types) searchParams.set('types', params.types);
  if (params.range) searchParams.set('range', params.range);
  const qs = searchParams.toString();
  return apiClient.get<TimelineResponse>(
    `/api/v1/aquariums/${aquariumId}/timeline${qs ? `?${qs}` : ''}`,
  );
}
